/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import NavigationAccessories from '../components/Navigation/Accessories';
import NavigationItem from '../components/Navigation/Item';
import NavigationProjectTitle from '../components/Navigation/ProjectTitle';
import SkinToneFilters from '../components/Navigation/SkinToneFilters';
import {
    editProduct,
    removeProduct,
    selectSection,
    selectSectionAndCategory,
    setActiveFilterButton,
    updateProjectTitle,
    setSkinTone,
    addBuild, 
} from '../actions';
import SelectedProduct from '../entities/SelectedProduct';

/**
 * Navigation container
 *
 * @author John Noel <john.noel@joipolloi.com>
 * @author Matt Haynes <matt.haynes@joiopolloi.com>
 * @package Minifigs
 */

function getUniqueName(name, existingNames) {
    let newName = name;
    let counter = 1;

    // Check if the name already exists in the array
    while (existingNames.includes(newName)) {
        // Use regex to check if name ends with * followed by a number
        const match = newName.match(/\*(\d+)$/);

        if (match) {
            // Increment the existing number after the *
            counter = parseInt(match[1], 10) + 1;
            // Replace the old *number with the new incremented one
            newName = newName.replace(/\*(\d+)$/, `*${counter}`);
        } else {
            // If no *number at the end, append *1
            newName = `${name}*1`;
        }
    }

    return newName;
}
class Navigation extends Component {
    constructor(props) {
        super(props);
        this.sliderRef = React.createRef();
        this.state = {
            showEditProjectInput: props.skintone && props.projectTitle ? false : true,
            initialLoad: true,
            projectTitleError: false,
            skinToneError: false,
        };
        this.dialogModal = React.createRef();
    }

    componentDidMount() {
        if (!this.sliderRef) return;
        const { showEditProjectInput } = this.state;
        const { setEnableBuilder } = this.props;
        if (!showEditProjectInput) {
            setEnableBuilder(true);
        }

        // init Swiper:
        // eslint-disable-next-line no-unused-vars
        const swiper = new Swiper(this.sliderRef.current, {
            spaceBetween: 20,
            slidesPerView: 3.5,
            breakpoints: {
                480: {
                    slidesPerView: 3.5,
                },
                768: {
                    slidesPerView: 5.2,
                },
                1024: {
                    slidesPerView: 5.7,
                },
            },
        });
    }

    componentDidUpdate(prevProps) {
        const { initialLoad, showEditProjectInput } = this.state;
        const { projectTitle, setEnableBuilder, skintone, enableBuilder } = this.props;

        if ((projectTitle === null || skintone === null) && !showEditProjectInput) {
            this.setState({ showEditProjectInput: true }, () => {
                setEnableBuilder(false);
            });
            return;
        }

        if (projectTitle !== prevProps.projectTitle && !initialLoad && skintone) {
            this.setState({ showEditProjectInput: false }, () => {
                this.setState({ initialLoad: false });
                if (skintone) {
                    setEnableBuilder(true);
                }
            });
        }

        console.log({ enableBuilder: !enableBuilder });
        console.log({ showEditProjectInput });

        if ((!enableBuilder && showEditProjectInput && this.dialogModal?.current) || this.props.showNavigation) {
            this.dialogModal?.current?.close();
            this.dialogModal?.current?.showModal();
        } else {
            this.dialogModal?.current?.close();
        }
    }

    handleSaveProjectTitle = (projectTitleText) => {
        const { setEnableBuilder, skintone, dispatch, builds } = this.props;

        if (skintone) {
            this.setState({ skinToneError: false });
        } else {
            this.setState({ skinToneError: true });
        }

        if (projectTitleText && projectTitleText?.split('-')[0].replaceAll(' ', '') !== '') {
            if (skintone) {
                const newProjTitle = getUniqueName(
                    projectTitleText,
                    builds.map((build) => build.projectTitle)
                );

                dispatch(updateProjectTitle(this.props.currentBuildIndex, newProjTitle));
            }

            this.setState({ showEditProjectInput: false }, () => {
                if (skintone) {
                    setEnableBuilder(true);
                }
                this.setState({ projectTitleError: false });
            });
        } else {
            this.setState({ projectTitleError: true });
        }
    };

    handleShowEditProjectTitle = () => {
        const { skintone, setEnableBuilder } = this.props;

        this.setState({ showEditProjectInput: true }, () => {
            if (skintone) {
                setEnableBuilder(false);
            }
        });
    };

    render() {
        const { showEditProjectInput, projectTitleError, skinToneError } = this.state;
        const {
            projectTitle,
            selected,
            activeSection,
            dispatch,
            setEnableBuilder,
            skintone,
            torsoOverlays,
            loading,
            sections: navigationItems,
            currentBuildIndex,
            buying,
        } = this.props;

        return (
            <nav className="navigation">
                <dialog
                    className={classNames('navigation__modal', {
                        hide: buying,
                    })}
                    ref={this.dialogModal}
                >
                    <>
                        <h2 className="navigation__subTitle">Start your build</h2>
                        <SkinToneFilters
                            projectTitle={projectTitle}
                            setEnableBuilder={setEnableBuilder}
                            activeSection={activeSection}
                            showEditProjectInput={this.state.showEditProjectInput}
                            skinToneError={skinToneError}
                            titleText="Choose a skin tone"
                        />

                        <NavigationProjectTitle
                            projectTitle={projectTitle}
                            showEditProjectInput={showEditProjectInput}
                            updateProjectTitle={(projectTitle, skintone) => {
                                dispatch(updateProjectTitle(currentBuildIndex, projectTitle));
                                if (skintone) dispatch(setSkinTone(currentBuildIndex, skintone));
                            }}
                            setShowEditProjectTitle={this.handleShowEditProjectTitle}
                            saveProjectTitle={this.handleSaveProjectTitle}
                            setEnableBuilder={setEnableBuilder}
                            projectTitleError={projectTitleError}
                        />
                    </>
                </dialog>

                <div className="navigation__sectionNavigation">
                    <h2 className="navigation__subTitle">Start Building</h2>

                    <ul className="navigation__sectionNavigationButtons" ref={this.sliderRef}>
                        <div className="swiper-wrapper">
                            {navigationItems &&
                                navigationItems.map((navItem) =>
                                    navItem.id === 'accessories' ? (
                                        <div className="swiper-slide" key={navItem.id}>
                                            <NavigationAccessories
                                                selected={[
                                                    selected.accessory1,
                                                    selected.accessory2,
                                                    selected.accessory3,
                                                    selected.accessory4,
                                                ]}
                                                active={activeSection}
                                                onSelect={(sectionId) => dispatch(selectSection(sectionId))}
                                                onEdit={(sectionId) => dispatch(editProduct(sectionId))}
                                                onRemove={(sectionId) =>
                                                    dispatch(removeProduct(currentBuildIndex, sectionId))
                                                }
                                                displayProducts={(catInfo) => {
                                                    dispatch(setActiveFilterButton(null));
                                                    dispatch(selectSectionAndCategory(catInfo));
                                                }}
                                                loading={loading}
                                                accessoriesItem={navItem}
                                            />
                                        </div>
                                    ) : (
                                        <div className="swiper-slide" key={navItem.id}>
                                            <NavigationItem
                                                {...navItem}
                                                key={navItem.id}
                                                selected={selected[navItem.id]}
                                                isActive={activeSection == navItem.id}
                                                categoryInfo={navItem}
                                                displayProducts={(catInfo) => {
                                                    dispatch(setActiveFilterButton(null));
                                                    dispatch(selectSectionAndCategory(catInfo, null, skintone));
                                                }}
                                                torsoOverlays={torsoOverlays ? torsoOverlays : null}
                                                loading={loading}
                                            />
                                        </div>
                                    )
                                )}
                        </div>
                    </ul>
                </div>

                <div className="navigation__previewFigure">
                    <button
                        onClick={() => {
                            const previewContainer = document.querySelector('.preview-container');
                            previewContainer.scrollIntoView({ behavior: 'smooth' });
                        }}
                    >
                        Preview your fig
                    </button>
                </div>
            </nav>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        currentBuildIndex: state.currentBuildIndex,
        selectedCategory: state.browser.selectedCategory,
        projectTitle: state.builds[state.currentBuildIndex].projectTitle,
        cost: SelectedProduct.calculateCost(state.builds[state.currentBuildIndex].selected),
        selected: state.builds[state.currentBuildIndex].selected,
        activeSection: state.navigation.selected,
        skintone: state.builds[state.currentBuildIndex].skintone,
        torsoOverlays: state.builds[state.currentBuildIndex].torsoOverlays,
        loading: state.loading,
        sections: state.sections,
        buying: state.buying,
        showNavigation: state.showNavigation,
        builds: state.builds,
    };
};

export default connect(mapStateToProps)(Navigation);
